'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const Translator = require('./../../../../core/translator');
const FormBuilder = require('./../../builder');
const Loader = require('./../../../../services/loader');

const mailchimpRepository = require('./repository/mailchimpRepository');

let ElementClass = require('./../../elementClass');

const indexTpl = require('./template/index.hbs');

FormBuilder.register('newsletter', function(config) {
    let $tpl;
    let $connectArea;
    let $connectedArea;
    let $select;
    let $currentWrap;
    let self = {};
    let mailchimpData = null;
    let currentListId = null;

    self = new ElementClass(config);

    self.render = function($wrap) {
        $tpl = jQuery(indexTpl());
        $connectArea = $tpl.find('.connect-area');
        $connectedArea = $tpl.find('.connected-area');
        $select = $connectedArea.find('select');

        $currentWrap = $wrap;

        if (config.value.mailchimp && config.value.mailchimp['current_list']) {
            currentListId = config.value.mailchimp['current_list'];
        }

        if (config.value.mailchimp && config.value.mailchimp.token) {
            let configMailchimpValue = config.value.mailchimp;

            $connectArea.addClass('d-none');
            self.displayConnectedArea(configMailchimpValue.token, configMailchimpValue.dc, configMailchimpValue['account_name']);
        } else {
            $connectedArea.addClass('d-none');
        }

        $connectArea.find('.btn').on('click', function() {
            mailchimpRepository.getInformation().done(function(configMailchimp) {
                window.open(`http://login.mailchimp.com/oauth2/authorize?response_type=code&client_id=${configMailchimp['client_id']}&redirect_uri=${configMailchimp['redirect_url']}`, '_blank', 'width=600,height=500');

                window.addEventListener('message', function(event) {
                    if (event.origin === configMailchimp.origin && event.data.code) {
                        Loader.start($wrap);
                        mailchimpRepository.getToken(event.data.code).done(function(res) {
                            mailchimpData = res;

                            self.displayConnectedArea(res.token, res.dc, res['account_name']);
                        });
                    }
                }, false);
            });

            return false;
        });

        $wrap.append($tpl);
    };

    self.displayConnectedArea = function(token, dc, username) {
        Loader.start($currentWrap);

        mailchimpRepository.getLists(token, dc).done(function(lists) {
            Loader.stop($currentWrap);
            $connectedArea.removeClass('d-none');
            $connectArea.addClass('d-none');

            $connectedArea.find('.user-area').html(Translator.translate('mailchimp_account_connected') + ': ' + username);

            if (lists.length > 0) {
                _.forEach(lists, function(list) {
                    let $option = jQuery(`<option value="${list.id}">${list.name}</option>`);

                    if (list.id === currentListId) {
                        $option.prop('selected', true);
                    }

                    $select.append($option);
                });
            } else {
                $connectedArea.find('.warning').removeClass('d-none');
            }
        });
    };

    self.getData = function() {
        let data = {
            'mailchimp': mailchimpData || config.value.mailchimp || {},
        };
        let $option = $select.find('option:selected');

        if ($option.length) {
            data.mailchimp['current_list'] = $option.val();
        }

        return data;
    };

    return self;
});
